import axios from 'axios';

const addOtherOption = (data) => {
  return data.concat({
    key: -1,
    businessName: 'Company not found.',
  });
};
const addNoOption = (data) => {
  return data;
};

const searchAbn = (endpoint, abn) =>
  axios
    .get(`${endpoint}/GetAbrDetailsByAbn/${abn}`)
    .then((response) => addNoOption(response?.data))
    .catch((error) => {
      return [];
    });

const searchAcn = (endpoint, acn) =>
  axios
    .get(`${endpoint}/GetAbrDetailsByAcn/${acn}`)
    .then((response) => addNoOption(response?.data))
    .catch((error) => {
      return [];
    });

const searchByBusinessName = (endpoint, businessName, maxResult) =>
  axios
    .get(`${endpoint}/ABRSearchByBusinessName?searchString=${businessName}&maxResults=${maxResult}&activeABNsOnly=Y`)
    .then((response) => addNoOption(response?.data))
    .catch((error) => {
      return [];
    });

export const OrganisationSearchAutoCompleteService = {
  getDetailByAbn: (endpoint, abn) => searchAbn(endpoint, abn),
  getDetailByAcn: (endpoint, acn) => searchAcn(endpoint, acn),

  searchByAbnAcnBusinessName: (endpoint, term, maxResult) => {
    let cleanedSearchString = term.replace(/\s/g, '');
    const abnRegex = /^\d{11}$/;
    const acnRegex = /^\d{9}$/;

    if (cleanedSearchString === '') return [];

    if (cleanedSearchString.match(abnRegex)) {
      return searchAbn(endpoint, cleanedSearchString);
    } else if (cleanedSearchString.match(acnRegex)) {
      return searchAcn(endpoint, cleanedSearchString);
    } else {
      return searchByBusinessName(endpoint, term, maxResult);
    }
  },
};
